<template>
  <div>
    <div
      ref="modal"
      class="modal fade"
      :class="{ show: active, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("CreateTxt") }} Proforma Invoice</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              v-on:click="$emit('closeModal')"
              aria-label="btn-close"
            ></button>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="name" class="form-label">Company</label>
                        <multiselect
                          @search-change="asyncSearchCompany"
                          v-model="company"
                          :options="fetchCompany"
                          label="name"
                          :searchable="true"
                          track-by="name"
                          @open="removeReadonly"
                          ref="inputCompany"
                          placeholder="Please Select Company"
                          disabled
                          @input="selectedCompany"
                        >
                          <span slot="noResult">-</span>
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="vehicle_no" class="form-label">{{
                          $t("vehicle_no")
                        }}</label>
                        <input
                          id="vehicle_no"
                          class="form-control"
                          v-model="forms.vehicle_no"
                          disabled
                          name="vehicle_no"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="sold_to_party" class="form-label"
                          >Sold To Party</label
                        >
                        <input
                          id="sold_to_party"
                          class="form-control"
                          v-model="forms.sold_to_party"
                          name="sold_to_party"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="equipment_description" class="form-label">{{
                          $t("type_truck")
                        }}</label>
                        <input
                          id="equipment_description"
                          class="form-control"
                          disabled
                          v-model="forms.equipment_description"
                          name="equipment_description"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="load_id" class="form-label">Load Id</label>
                        <input
                          id="load_id"
                          v-model="forms.load_id"
                          disabled
                          class="form-control"
                          name="load_id"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="origin" class="form-label">Origin</label>
                        <input
                          id="origin"
                          class="form-control"
                          v-model="forms.origin"
                          name="origin"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="shipment_numbers" class="form-label"
                          >Shipment Number</label
                        >
                        <input
                          id="shipment_numbers"
                          class="form-control"
                          disabled
                          v-model="forms.shipment_numbers"
                          name="shipment_numbers"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="destination" class="form-label"
                          >Destination</label
                        >
                        <input
                          id="destination"
                          class="form-control"
                          v-model="forms.destination"
                          name="destination"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="uom" class="form-label">UOM</label>
                        <input
                          id="uom"
                          class="form-control"
                          disabled
                          v-model="forms.uom"
                          name="uom"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="name" class="form-label">{{
                          $t("loadingDate")
                        }}</label>
                        <Datepicker
                          v-model="forms.loading_date_temp"
                          :bootstrap-styling="true"
                          format="dd-MM-yyyy"
                          placeholder="Please Select Date..."
                        ></Datepicker>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="qty" class="form-label">Qty</label>
                        <input
                          id="qty"
                          class="form-control"
                          disabled
                          v-model="forms.qty"
                          name="qty"
                          type="number"
                        />
                      </div>
                    </div>

                     <div class="col-6">
                      <div class="mb-3">
                        <label for="qty" class="form-label">Ship To</label>
                        <input
                          id="ship_to"
                          class="form-control"
                          disabled
                          v-model="forms.ship_to"
                          name="ship_to"
                          type="text"
                        />
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="mb-3">
                        <label for="name" class="form-label">{{
                          $t("unloadingDate")
                        }}</label>
                        <!-- <input id="name" class="form-control" name="name" type="text"> -->
                        <Datepicker
                          v-model="forms.unloading_date_temp"
                          :bootstrap-styling="true"
                          format="dd-MM-yyyy"
                          placeholder="Please Select Date..."
                        ></Datepicker>
                      </div>
                    </div>
                    <!-- <div class="col-6">
                      <div class="mb-3">
                        <label for="delivery_order" class="form-label"
                          >Delivery Order</label
                        >
                        <input
                          id="delivery_order"
                          class="form-control"
                          v-model="forms.delivery_order"
                          name="name"
                          type="text"
                        />
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <label class="form-label"><b>Billable Rate</b></label>
                        <CurrencyInput
                          v-model="forms.billable_rate"
                          :options="{ currency: 'IDR' }"
                          class="form-control"
                          @input="inputBillableRate"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label class="form-label"><b>Total</b></label>
                        <CurrencyInput
                          :value="total"
                          :options="{ currency: 'IDR' }"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div
                      class="col-12 my-3"
                      v-if="
                        additionalHeader !== null &&
                        additionalHeader?.length > 0
                      "
                    >
                      <h5>Charges</h5>
                    </div>
                    <div
                      class="col-6"
                      v-for="(data, index) in additionalHeader"
                      :key="index"
                    >
                      <div class="mb-3">
                        <label class="form-label">{{
                          data.add_cost_name
                        }}</label>
                        <!-- <input class="form-control" name="add_cost_name" type="text"> -->
                        <CurrencyInput
                          :value="forms?.sub[index]?.value"
                          :options="{ currency: 'IDR' }"
                          class="form-control"
                          @input="updateValue($event, index, 'value')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              {{ $t("close_txt") }}
            </button>
            <button
              class="btn btn-success"
              type="submit"
              :disabled="isLoading"
              @click="submitData"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm ms-auto"
                role="status"
                aria-hidden="true"
              ></span>
              {{ $t("addDetail") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import CurrencyInput from "@/components/_partials/inputCurrency";
// import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker";
export default {
  name: "modalProformaInvoiceAdd",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
  },
  components: {
    // DateRangePicker,
    multiselect: multiselect,
    CurrencyInput,
    Datepicker,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
        if (this.data) {
          this.forms = {};
          // this.forms = this.data;
          this.forms = {
            company_id           : this.data.company_id,
            company_name         : this.data.company_name,
            load_id              : this.data.load_id,
            vehicle_no           : this.data.vehicle_no,
            equipment_description: this.data.equipment_description,
            origin               : this.data.origin,
            destination          : this.data.destination,
            delivery_order       : this.data.delivery_order,
            shipment_numbers     : this.data.shipment_numbers,
            uom                  : this.data.uom,
            qty                  : this.data.qty,
            ship_to              : this.data.ship_to,
            sold_to_party        : this.data.sold_to_party,
          };
          this.company = {
            company_id: this.data.company_id,
            name: this.data.company_name,
          };

          this.forms.loading_date_temp = this.data.loading_date;
          this.forms.unloading_date_temp = this.data.unloading_date;
          this.forms.billable_rate = 0;
          this.forms.sub = [];
          this.forms.total = 0;
          this.forms.status_flow = "MANUAL";
          this.getChargeHeader();
        }
      },
      immediate: true,
      deep: true,
    },
    "forms.loading_date_temp": function (newVal) {
      if (newVal !== null || newVal !== undefined) {
        const date = new Date(newVal);
        this.forms.loading_date = date.toISOString().slice(0, 10);
      }
    },
    "forms.unloading_date_temp": function (newVal) {
      if (newVal !== null || newVal !== undefined) {
        const date = new Date(newVal);
        this.forms.unloading_date = date.toISOString().slice(0, 10);
      }
    },
  },
  data() {
    // const startDate = new Date();
    // const endDate = new Date();
    return {
      isLoading: false,
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      active: this.showModal,
      fetchCompany: [],
      totalRecords: 0,
      dateFilter: {
        startDate: null,
        endDate: null,
      },
      forms: {
        sub: [],
        total:0
      },
      columns: [],
      rows: [],
      company: {},
      proforma_invoice_header_id: null,
      rowsSelection: null,
      additionalHeader: null,
      sub: [],
      total:0
    };
  },
  methods: {
    calculateTotals(){
      let total = 0;
      this.forms.sub.forEach((item)=>{
        total += parseFloat(item?.value ? item.value : 0);
      })

      this.total = total;
    },
    inputBillableRate(event) {
      let arr = null;
      this.forms.sub.forEach((item, key) => {
        if (item.charge_code_header_name.toLowerCase() == "billable rate") {
          arr = key;
        }
      });

      if (arr !== null) {
        this.$set(this.forms.sub[arr],'value',event);
      } else {
        this.forms.sub.push({
          charge_code_header_id: null,
          charge_code_header_name: "Billable Rate",
          value: event,
        });
      }

      this.calculateTotals();
    },
    updateValue(event, i, key) {
      if (this.forms?.sub[i] === undefined) {
        let currentHeader = this.additionalHeader[i];
        this.forms.sub[i] = {
          charge_code_header_id  : currentHeader.charge_code_header_id,
          charge_code_header_name: currentHeader.add_cost_name,
          value                  : event,
        };
      } else {
        const sub = { ...this.forms.sub[i] };
        sub[key] = event;
        this.forms.sub.splice(i, 1, sub);
      }
      this.calculateTotals();

    },
    selectedCompany(ev) {
      this.forms.company_id = ev.company_id;
      this.forms.company_name = ev.name;
      this.getChargeHeader();
    },
    getChargeHeader() {
      const baseURI =
        this.$settings.endPointProformaInvoice +
        `v1/company-cost/index?company_id=${this.forms.company_id}&per_page=-1&sort_field=charge_code_header_id&sort_type=asc`;
      return this.$http.get(baseURI).then((response) => {
        let res = response.data.datas.data;
        res.forEach((item, index) => {
          this.forms.sub[index] = {
            charge_code_header_id  : item.charge_code_header_id,
            charge_code_header_name: item.add_cost_name,
            value                  : 0,
          };
        });
        this.calculateTotals()
        if (res?.length <= 0) {
          this.error("No Additional Header");
        }
        this.additionalHeader = res;
      });
    },
    submitData() {
      let header = this.additionalHeader.map((item) => {
        return item.add_cost_name.toLowerCase().replaceAll(" ", "_");
      });

      let check = false;
      let datas = { ...this.forms };
      this.forms.sub.forEach((item) => {
        if (item.charge_code_header_name.toLowerCase() == "billable rate") {
          check = true;
          item.value = this.forms.billable_rate;
          return true;
        }
      });

      if (!check) {
        this.forms.sub.push({
          charge_code_header_id  : null,
          charge_code_header_name: "Billable Rate",
          value                  : this.forms.billable_rate,
        });
      }
      if(datas.loading_date == undefined || datas.loading_date == ""){
        datas.loading_date = new Date(this.forms.loading_date_temp).toISOString().slice(0,10);
      }
      if(datas.unloading_date == undefined || datas.unloading_date == ""){
        datas.unloading_date = new Date(this.forms.unloading_date_temp).toISOString().slice(0,10);
      }
      datas.sub = [];
      this.forms.sub.forEach((item) => {
        if (item.value > 0) {
          datas.sub.push(item);

          let textLabel = item.charge_code_header_name.replaceAll(" ","_").toLowerCase();

          datas[textLabel] = item.value;
        }
      });
      datas.total = this.total;

      let arr = [];
      arr.push(datas);
      this.$emit("sendData", arr, header);
    },
    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?limit=10&name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    removeReadonly() {
      this.$nextTick(() => {
        const input = this.$refs.inputCompany.$el.querySelector(
          ".multiselect__input"
        );
        if (input && input.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },
  },

  mounted() {
    this.loadCompany();
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>
